var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessLangCloud3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30211 16.9483C5.14662 13.7956 2.37455 4.4661 7.61934 1.18835C14.4382 -3.07326 17.465 5.14274 19.1819 9.82945C18.069 3.87985 25.9083 4.89841 25.7125 11.7677C34.1931 4.98095 42.0377 16.6856 32.7075 21.0468C35.4219 21.316 38.7744 23.1579 36.2466 26.0427C33.7968 28.839 26.0118 29.1481 22.852 29.3551C18.5655 29.6355 12.8844 29.6826 8.60843 29.1049C-6.47749 27.0684 1.22956 8.54233 9.30211 16.9483Z",
    fill: "#FFE0E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessLangCloud3);
export default __webpack_public_path__ + "static/media/assess-lang-cloud3.ab4d38482d441f0aa6497adef1f6736d.svg";
export { ForwardRef as ReactComponent };